<template>
  <div class="TestCode">
    <GoogleMap
      api-key="AIzaSyA-GvE5WQs3JfeeGKFS9GhjjdAIxoIrEcs"
      style="width: 100%; height: 100vh"
      :center="center"
      :zoom="17"
    >
      <Marker :options="markerOptions">
        <InfoWindow>
          <div id="content">
            <div id="siteNotice"></div>
            <h3>โปลิเทคนิคลานนา เชียงใหม่</h3>
            <div id="bodyContent">
              <p>
                go to googlemap: โปลิเทคนิคลานนา เชียงใหม่ ,
                <a
                  :href="`https://www.google.com/maps?q=โปลิเทคนิคลานนา`"
                  target="_blank"
                >
                  https://www.google.com/maps</a
                >
              </p>
            </div>
          </div>
        </InfoWindow>
      </Marker>
      <Marker
        v-for="(location, i) in locations"
        :key="i"
        :options="{ position: location }"
      >
        <InfoWindow>
          <div id="content">
            <div id="siteNotice"></div>
            <h3>{{ nameLocation[i].name }}</h3>
            <div id="bodyContent" v-if="linkLocation[i].link == undefined">
              <p>
                go to googlemap: {{ nameLocation[i].name }},
                <a
                  :href="`https://www.google.com/maps?q=${location.lat}, ${location.lng}`"
                  target="_blank"
                >
                  https://www.google.com/maps</a
                >
              </p>
            </div>
            <div id="bodyContent" v-else>
              <p>
                go to googlemap: {{ nameLocation[i].name }},
                <a :href="`${linkLocation[i].link}`" target="_blank">
                  https://www.google.com/maps</a
                >
              </p>
            </div>
          </div>
        </InfoWindow>
      </Marker>
    </GoogleMap>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import $ from "jquery";
import { GoogleMap, Marker, InfoWindow } from "vue3-google-map";

window.$ = window.jQuery = $;
export default {
  components: {
    GoogleMap,
    Marker,
    InfoWindow,
  },

  data() {
    return {
      center: { lat: 18.81362037237321, lng: 98.99218175440934 },
      locations: [],
      nameLocation: [],
      linkLocation: [],
      markerOptions: {
        position: { lat: 18.813389590271424, lng: 98.99221258138324 },
        // label: {
        //   text: ".", // ข้อความบน Marker
        //   color: "#000000", // สีดำของข้อความ
        //   fontSize: "14px", // ขนาดตัวอักษร
        //   fontWeight: "bold", // ตัวหนา
        // },
        title: "LADY LIBERTY",
        icon: {
          url: "https://www.lannapoly.ac.th/admission/images/logo.png", // อ้างอิงหลังโหลด API
          fillColor: "#FF0000",
          fillOpacity: 1,
          strokeColor: "#FFFFFF",
          strokeWeight: 1,
          scaledSize: { width: 40, height: 40 }, // ตั้งค่าขนาดไอคอน
        },
      },
    };
  },
  async mounted() {
    // if (GoogleMap) {
    //   console.log("test");
    //   const scaledSize = { width: 40, height: 40 }; // ใช้ตัวแปรในรูปแบบของอ็อบเจ็กต์
    //   this.markerOptions.icon = {
    //     ...this.markerOptions.icon, // คัดลอกค่าที่มีอยู่เดิม
    //     scaledSize: scaledSize,
    //   };
    // }
    await this.$store.dispatch("MapDormitory/GET_Location_Dormitory");
    for (const item of this.DataListLocationDormitory) {
      const [lat, lng] = item.apa_location
        .split(",")
        .map((value) => parseFloat(value));

      this.locations.push({ lat: lat, lng: lng });
      this.nameLocation.push({ name: item.apa_apmnm });
      this.linkLocation.push({ link: item.apa_link_location });
    }
  },
  watch: {},
  methods: {},
  computed: {
    ...mapGetters({
      DataListLocationDormitory: "MapDormitory/_getDataLocationDormitory",
    }),
  },
};
</script>

<style></style>
